export const normalizeCaseReadId = (value) => {
    if (typeof value !== 'number' && typeof value !== 'string') return null;
    const normalized = String(value).trim();
    if (!/^[1-9][0-9]*$/.test(normalized)) return null;
    return normalized;
};

// Client readiness/identity validation only; API authorization remains authoritative.
export const caseReadScope = (data, routeCaseId) => {
    const caseIsActive = data?.case?.deleted == null
        || data.case.deleted === 0
        || data.case.deleted === '0';
    if (!caseIsActive) return null;

    const caseId = normalizeCaseReadId(data?.case?.id ?? data?.case?.case_id);
    const leadId = normalizeCaseReadId(data?.lead?.id);
    if (!caseId || !leadId || caseId !== normalizeCaseReadId(routeCaseId)) return null;
    if (data?.case?.case_id != null && normalizeCaseReadId(data.case.case_id) !== caseId) return null;
    if (data?.case?.lead_id != null && normalizeCaseReadId(data.case.lead_id) !== leadId) return null;

    return {
        caseId,
        leadId,
        templateId: normalizeCaseReadId(data?.case?.template_id)
    };
};

export const caseSectionsFromResponse = (data) => {
    if (data?.success === false || !Array.isArray(data?.sections)) return null;
    return data.sections.filter(section => section !== null
        && typeof section === 'object'
        && !Array.isArray(section)
        && normalizeCaseReadId(section.id) !== null
        && typeof section.name === 'string');
};
